enum UnlockableModalType {
  ShareInfo,
  SeeInfo,
  UnlockableDetails,
}

export default UnlockableModalType;
